import SearchForEveryone from './SearchForEveryone';

export default SearchForEveryone;